import { Edit, Image as ImageIcon, Search, Trash2, X } from 'lucide-react';
import { useContext, useEffect, useState } from 'react';
import '../../../../assets/css/screens/admin/dashboard/admincategories/AdminCategories.css';

import axios from 'axios';
import AppContext from '../../../../context/AppContext';

const EMPTY_FORM = {
  name: '',
  description: '',
  status: '',
  image: null,
  imagePreview: null,
};
/* ── Shared Image Upload Field ── */
const ImageUploadField = ({ preview, onChange, onRemove }) => (
  <div className="ac-upload-area">
    {preview ? (
      <div className="ac-upload-preview">
        <img src={preview} alt="Preview" />
        <button className="ac-upload-remove" onClick={onRemove} type="button"><X size={15} /></button>
      </div>
    ) : (
      <label className="ac-upload-label">
        <input type="file" accept="image/*" onChange={onChange} style={{ display: 'none' }} />
        <ImageIcon size={32} />
        <span>Click to upload image</span>
        <span className="ac-upload-hint">PNG, JPG up to 5MB</span>
      </label>
    )}
  </div>
);

const Admincategory = () => {
const {baseUrl, baseUrlForFile, authToken} = useContext(AppContext);

  const [category, setCategory] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("Active");
  const [categoryImage, setCategoryImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [addUploadLoading, setAddUploadLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [search, setSearch] = useState('');
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(null);   // category object
  const [deleteModal, setDeleteModal] = useState(null);  // category object




  const createCategory = () => {


    const formData = new FormData();
    formData.append("categoryName", categoryName);
    formData.append("description", description);
    formData.append("status", status ? 1 : 0);
    formData.append("categoryImage", categoryImage);

    setAddUploadLoading(true);

    axios
      .post(`${baseUrl}/whadmin/whcategory`, formData, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
      .then(() => {
        setAddUploadLoading(false);
        viewAllCategory();
        setAddModal(false);
      })
      .catch((error) => {
        console.error(error);
        setAddUploadLoading(false);
        alert("Network error! Please try again.");
      });
  }

  // update
  const updateCategory = () => {

    const formData = new FormData();
    formData.append("id", selectedCategory.id);
    formData.append("categoryName", categoryName);
    formData.append("description", description);
  formData.append("status", status === "Active" ? 1 : 0);
    formData.append("categoryImage", categoryImage);

    setAddUploadLoading(true);

    axios
      .post(`${baseUrl}/whadmin/updateWhCategory`, formData, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
      .then((response) => {
        console.log(response.data);
        viewAllCategory();
        setAddUploadLoading(false);
        setEditModal(null);
        alert("Category updated successfully!");
      })


      .catch((error) => {
        console.error(error);
        setAddUploadLoading(false);
        alert("Network error! Please try again.");
      });

  }
  // delete
  const deleteCategory = (idToDelete) => {
    console.log("*************");
    console.log(idToDelete);
    console.log("*************");
    const formData = new FormData();
    formData.append("id", idToDelete);
    axios
      .post(`${baseUrl}/whadmin/deleteWhCategory`, formData, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
      .then((response) => {
        console.log(response.data);
        viewAllCategory();
        setDeleteModal(false);
        alert("Category deleted successfully!");
      })
      .catch((error) => { console.log(error) })
  }


  // view
  const viewAllCategory = () => {
    axios.get(`${baseUrl}/whadmin/viewAllCategory`,{
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  }

    )
      .then((response) => {
        setCategory(response.data.category);
        // updateStats(response.data.category);
      })
      .catch((error) => {
        console.log(error);
      });
  };




  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        alert("Please upload a valid image");
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        alert("Image size must be less than 2MB");
        return;
      }
      setCategoryImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };


  useEffect(() => {
    viewAllCategory();
  }, []);

  const filtered = category.filter(c =>
    (c.categoryName || '').toLowerCase().includes(search.toLowerCase())
  );


  const confirmDelete = () => {
    deleteCategory(deleteModal.id);
  };

  const openAdd = () => {
    setCategoryName("");
    setDescription("");
    setStatus("Active");
    setCategoryImage(null);
    setImagePreview(null);

    setAddModal(true);
  };

  const openEdit = (cat) => {
    setSelectedCategory(cat);

    setCategoryName(cat.categoryName);
    setDescription(cat.description);
    setStatus(cat.status ? "Active" : "Inactive");
  setImagePreview(
  cat.categoryImage
    ? `${baseUrlForFile}/${cat.categoryImage}`
    : null
);

    setEditModal(cat);
  };







  /* ── TOGGLE ── */
  const toggleStatus = (id) =>
    setCategory(prev => prev.map(c => c.id === id ? { ...c, status: !c.status } : c));

  return (
    <div className="ac-page">

      {/* ── Header ── */}
      <div className="ac-header">
        <div>
          <h2 className="ac-title">category</h2>
          <p className="ac-subtitle">Manage service category</p>
        </div>
        <div className="ac-header-actions">
          <div className="ac-search">
            <Search size={16} className="ac-search-icon" />
            <input className="ac-search-input" placeholder="Search category..." value={search}
              onChange={e => setSearch(e.target.value)} />
          </div>
          <button className="ac-add-btn" onClick={openAdd}>+ Add Category</button>
        </div>
      </div>

      {/* ── Grid ── */}
      <div className="ac-grid">
        {filtered.map((cat, i) => (
          <div key={cat.id} className="ac-card" style={{ animationDelay: `${i * 0.05}s` }}>
            <div className="ac-card-top">
              <div className="ac-card-img">
                <img
                  src={`${baseUrlForFile}/${cat.categoryImage}`}
                  alt={cat.categoryName}
                />
              </div>
              <label className="ac-toggle">
                <input type="checkbox" checked={cat.status} onChange={() => toggleStatus(cat.id)} />
                <span className="ac-toggle-slider" />
              </label>
            </div>
            <div className="ac-card-body">
              <h5 className="ac-card-name">{cat.categoryName}</h5>
              <p className="ac-card-services">{cat.totalServices || 0} services</p>
              <p className="ac-card-desc">{cat.description}</p>
            </div>
            <div className="ac-card-actions">
              <button className="ac-btn-edit" onClick={() => openEdit(cat)}>
                <Edit size={14} /> Edit
              </button>
              <button className="ac-btn-delete" onClick={() => setDeleteModal(cat)}>
                <Trash2 size={14} /> Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* ════ ADD MODAL ════ */}
      {addModal && (
        <div className="ac-overlay" onClick={() => setAddModal(false)}>
          <div className="ac-modal" onClick={e => e.stopPropagation()}>
            <div className="ac-modal-header">
              <h3 className="ac-modal-title">Add Category</h3>
              <button className="ac-modal-close" onClick={() => setAddModal(false)}><X size={18} /></button>
            </div>
            <div className="ac-modal-body">
              <div className="ac-field">
                <label className="ac-label">Category Name</label>
                <input className="ac-input" placeholder="e.g. Electrical" value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)} />
              </div>
              <div className="ac-field">
                <label className="ac-label">Description</label>
                <textarea className="ac-textarea" placeholder="Describe this category..." rows={3}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)} />
              </div>
              <div className="ac-field">
                <label className="ac-label">Status</label>
                <select className="ac-select" value={status}
                  onChange={(e) => setStatus(e.target.value)}>
                  <option>Active</option>
                  <option>Inactive</option>
                </select>
              </div>
              <div className="ac-field">
                <label className="ac-label">Category Image</label>
                <ImageUploadField
                  preview={imagePreview}
                  onChange={handleImageUpload}

                />
              </div>
            </div>
            <div className="ac-modal-footer">
              <button className="ac-btn-cancel" onClick={() => setAddModal(false)}>Cancel</button>
              <button className="ac-btn-submit"
                onClick={createCategory}
                disabled={addUploadLoading}>
                Add Category</button>
            </div>
          </div>
        </div>
      )}

      {/* ════ EDIT MODAL ════ */}
      {editModal && (
        <div className="ac-overlay" onClick={() => setEditModal(null)}>
          <div className="ac-modal" onClick={e => e.stopPropagation()}>
            <div className="ac-modal-header">
              <h3 className="ac-modal-title">Edit Category</h3>
              <button className="ac-modal-close" onClick={() => setEditModal(null)}><X size={18} /></button>
            </div>
            <div className="ac-modal-body">
              <div className="ac-field">
                <label className="ac-label">Category Name</label>
                <input className="ac-input" value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)} />
              </div>
              <div className="ac-field">
                <label className="ac-label">Description</label>
                <textarea className="ac-textarea" rows={3} value={description}
                  onChange={(e) => setDescription(e.target.value)} />
              </div>
              <div className="ac-field">
                <label className="ac-label">Status</label>
                <select className="ac-select" value={status}
                  onChange={(e) => setStatus(e.target.value)}>
                  <option>Active</option>
                  <option>Inactive</option>
                </select>
              </div>
              <div className="ac-field">
                <label className="ac-label">Category Image</label>
                <ImageUploadField
                  preview={imagePreview}
                  onChange={handleImageUpload}

                />
              </div>
            </div>
            <div className="ac-modal-footer">
              <button className="ac-btn-cancel" onClick={() => setEditModal(null)}>Cancel</button>
              <button className="ac-btn-submit" onClick={updateCategory} >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ════ DELETE CONFIRM MODAL ════ */}
      {deleteModal && (
        <div className="ac-overlay" onClick={() => setDeleteModal(null)}>
          <div className="ac-modal ac-modal--sm" onClick={e => e.stopPropagation()}>
            <div className="ac-modal-header">
              <h3 className="ac-modal-title">Delete Category</h3>
              <button className="ac-modal-close" onClick={() => setDeleteModal(null)}><X size={18} /></button>
            </div>
            <div className="ac-modal-body ac-delete-body">
              <div className="ac-delete-icon"><Trash2 size={32} /></div>
              <p className="ac-delete-msg">
                Are you sure you want to delete <strong>{deleteModal.categoryName}</strong>?
              </p>
              <p className="ac-delete-sub">This action cannot be undone.</p>
            </div>
            <div className="ac-modal-footer">
              <button className="ac-btn-cancel" onClick={() => setDeleteModal(null)}>Cancel</button>
              <button className="ac-btn-danger" onClick={() => {
                deleteCategory(deleteModal.id);

              }}>
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Admincategory;
